import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-14 20:05:03
 * @LastEditTime: 2022-01-12 16:49:29
 * @LastEditors: wangshengqiang
 * @Description: 坚持有效期选择组件
 */
import React from 'react';
import { FormItem, CertValidity } from '@/baseComponents';
import './index.less';
export default function RowCertValidity(props) {
  const {
    label,
    attrs,
    isBenefitFactor,
    isPremiumFactor,
    formKey,
    remark = {}
  } = props;
  const {
    placeholder
  } = attrs;
  const formItemProps = {
    label: label || '证件有效期',
    name: formKey,
    remark,
    fieldOption: {
      isBenefitFactor,
      isPremiumFactor,
      rules: [{
        required: true,
        message: '请输入'
      }]
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, formItemProps, {
    className: "c-row-cert-validity"
  }), /*#__PURE__*/React.createElement(CertValidity, {
    placeholder: placeholder
  }));
}